/* eslint-disable max-len */

interface Props {
    width?: string;
}

export const WorkleapLogo = ({ width }: Props) => {
    return (
        <svg width={width} viewBox="0 0 180 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#3C3C3C"
                d="M49.3,6.6c-6.5,0-11.1,4.3-11.1,10.9c0,6.5,4.2,11.2,11.1,11.2c6.5,0,11.1-4.4,11.1-11.2
	C60.4,11.2,56.1,6.6,49.3,6.6z M49.4,23.7c-3,0-5-2.4-5-6.2c0-3.6,2-5.9,5-5.9c3,0,5,2.3,5,5.9C54.3,21.2,52.4,23.7,49.4,23.7z
	 M99.2,6.6h-7.4l-8,8.5V0.6h-6v27.6h6v-6.3l3.1-3l5.8,9.3h6.9l-8.5-13.4L99.2,6.6z M101.5,28.2h6V0.6h-6V28.2z M148.7,10.4
	c-1.3-2.3-3.9-3.8-7.1-3.8c-5.5,0-9.4,4.5-9.4,11c0,6.6,3.9,11.2,9.5,11.2c2.8,0,5.1-1.1,6.4-3v2.5h6V7.1h-4.9L148.7,10.4z
	 M143.2,23.7c-2.9,0-4.9-2.6-4.9-6.3c0-3.6,2-6.1,4.9-6.1c2.9,0,4.9,2.5,4.9,6.1C148.1,21.1,146,23.7,143.2,23.7z M169.2,6.6
	c-3.2,0-5.8,1.5-7.1,3.8l-0.5-3.3h-4.9v0.2v27.4h6v-9c1.3,1.9,3.6,3,6.4,3c5.6,0,9.5-4.6,9.5-11.2C178.5,11.1,174.6,6.6,169.2,6.6z
	 M167.6,23.7c-2.9,0-4.9-2.6-4.9-6.2c0-3.5,2-6,4.9-6c2.9,0,4.9,2.5,4.9,6.1C172.4,21.2,170.5,23.7,167.6,23.7z M120.2,6.6
	c-6.3,0-10.7,4.6-10.7,11.2c0,6.5,4.6,11,11.1,11c4.6,0,8-2.2,9.4-6l-5.4-1.3c-0.6,1.5-2.3,2.3-4.2,2.3c-2.8,0-4.6-1.9-5-4.7h15
	l0-0.6c0.1-0.9,0.1-1.7,0-2.6C129.9,10,125.7,6.6,120.2,6.6z M115.7,15.4c0.6-2.5,2.4-4.1,4.6-4.1c2.3,0,3.9,1.4,4.2,4.1H115.7z
	 M67.6,11.2L67,7.1h-4.9v21.1h6V18c0-3.6,2.5-5.7,6.7-5.7h0.9V6.6h-0.6C71.4,6.6,69.1,8,67.6,11.2z M32.9,7.1l-5,15l-4.6-15h-5.9
	l-4.7,18.6l-5-18.6H1.5l7.6,27.6h6.5L20.4,16l4.5,12.7h7l7.4-21.6L32.9,7.1L32.9,7.1z"
            />
        </svg>
    );
};
